<script lang="ts">
export default {
  name: "BaseDropdownDivider",
};
</script>

<template>
  <li><hr class="dropdown-divider" /></li>
</template>
